export const DEFAULT_USE_CASE = "default";
export const DEFAULT_USE_CASE_NAME = "Default";

/**
 * Shown when a use case has no stored library label, or isn't returned by
 * /api/get_use_cases at all. Stored labels are DG-interpolated server-side.
 */
export const DEFAULT_FOLDER_LABEL = "Virtual Library";
